import FeaturesConfig from './Features.config'
import { servers } from '@/helpers'

/**
 * Transform servers urls into array
 *
 * @param {String|Array} urls
 */
const transformServerUrls = (urls) => {
  return urls instanceof Array
    ? [ ...urls ]
    : [ urls ]
}

export default Object.assign({}, ...Object.keys(servers)
  .map(id => {
    return {
      [id]: {
        id,
        type: servers[id].name,
        features: {
          ...FeaturesConfig,
          ...servers[id].features ? servers[id].features : {}
        },
        servers: [
          {
            id: 'hub',
            label: 'hub',
            urls: transformServerUrls(servers[id].hub)
          },
          {
            id: 'platform',
            label: 'platform',
            urls: transformServerUrls(servers[id].platform)
          },
          {
            id: 'game',
            label: 'game',
            urls: transformServerUrls(servers[id].game)
          },
          {
            id: 'tech_check',
            label: 'tech_check',
            urls: transformServerUrls(servers[id].check)
          },
          {
            id: 'score',
            label: 'score',
            urls: transformServerUrls(servers[id].scores)
          }
        ]
      }
    }
  }))
